export const segments = [
    {
        start: 4650.312,
        end: 4661.990,
        startPlay: 4654.212,
        ballX: 950,
        url: './detections/1_tracks_v8.json',
        offence_team: "away_team",
        offence_odds: {
            10: "6 / 4",
            85: "4 / 1",
            28: "3 / 1",
            18: "6 / 1",
            17: "5 / 1",
        },
        defence_odds: {
            27: "11 / 2",
            30: "10 / 1",
            45: "8 / 1",
            54: "33 / 1",
            91: "66 / 1",
            99: "66 / 1",
            97: "66 / 1",
            51: "66 / 1",
            24: "13 / 2",
            23: "10 / 1",
            20: "16 / 1",
        },
        progress_odds: {
            966: { under: "9 / 2", over: "2 / 13", yardage: 1.5 },
            978: { under: "4 / 1", over: "2 / 11", yardage: 2.5 },
            990: { under: "3 / 1", over: "1 / 4", yardage: 3.5 },
            1002: { under: "2 / 1", over: "2 / 5", yardage: 4.5 },
            1014: { under: "9 / 5", over: "4 / 9", yardage: 5.5 },
            1026: { under: "6 / 4", over: "8 / 15", yardage: 6.5 },
            1038: { under: "6 / 5", over: "4 / 6", yardage: 7.5 },
            1050: { under: "21 / 20", over: "4 / 5", yardage: 8.5 },
            1062: { under: "EVS", over: "5 / 6", yardage: 9.5 },
            1074: { under: "20 / 21", over: "9 / 10", yardage: 10.5 },
            1086: { under: "9 / 10", over: "10 / 11", yardage: 11.5 },
            1098: { under: "8 / 11", over: "EVS", yardage: 12.5 },
            1110: { under: "4 / 6", over: "6 / 5", yardage: 13.5 },
            1122: { under: "8 / 13", over: "13 / 10", yardage: 14.5 },
        },
    },
    {
        start: 6139.333,
        end: 6151.979,
        startPlay: 6143.433,
        ballX: 593,
        url: './detections/2_tracks_v8.json',
        offence_team: "away_team",
        offence_odds: {
            10: "4 / 1",
            13: "11 / 2",
            85: "4 / 1",
            88: "6 / 1",
        },
        defence_odds: {
            24: "6 / 1",
            23: "5 / 1",
            20: "16 / 1",
            27: "11 / 2",
            30: "13 / 2",
            51: "33 / 1",
            95: "66 / 1",
            91: "66 / 1",
            99: "66 / 1",
            21: "66 / 1",
        },
        progress_odds: {
            570: { under: "9 / 2", over: "2 / 13", yardage: 1.5 },
            558: { under: "4 / 1", over: "2 / 11", yardage: 2.5 },
            546: { under: "3 / 1", over: "1 / 4", yardage: 3.5 },
            534: { under: "2 / 1", over: "2 / 5", yardage: 4.5 },
            522: { under: "9 / 5", over: "4 / 9", yardage: 5.5 },
            510: { under: "6 / 4", over: "8 / 15", yardage: 6.5 },
            498: { under: "6 / 5", over: "4 / 6", yardage: 7.5 },
            486: { under: "21 / 20", over: "4 / 5", yardage: 8.5 },
            474: { under: "EVS", over: "5 / 6", yardage: 9.5 },
            462: { under: "20 / 21", over: "9 / 10", yardage: 10.5 },
            450: { under: "9 / 10", over: "10 / 11", yardage: 11.5 },
            438: { under: "8 / 11", over: "EVS", yardage: 12.5 },
            426: { under: "4 / 6", over: "6 / 5", yardage: 13.5 },
            414: { under: "8 / 13", over: "13 / 10", yardage: 14.5 },
        },
    },
    {
        start: 7448.007,
        end: 7459.985,
        startPlay: 7455.007,
        ballX: 575,
        url: './detections/3_tracks_v8.json',
        offence_team: "home_team",
        offence_odds: {
            86: "9 / 2",
            15: "11 / 2",
            33: "5 / 1",
            87: "8 / 1",
            88: "9 / 1",
        },
        defence_odds: {
            23: "9 / 2",
            24: "11 / 2",
            54: "7 / 1",
            45: "7 / 1",
            35: "66 / 1",
            90: "66 / 1",
            96: "66 / 1",
            93: "66 / 1",
            58: "33 / 1",
            31: "13 / 2",
            33: "10 / 1",
        },
        progress_odds: {
            594: { under: "9 / 2", over: "2 / 13", yardage: 1.5 },
            606: { under: "4 / 1", over: "2 / 11", yardage: 2.5 },
            618: { under: "3 / 1", over: "1 / 4", yardage: 3.5 },
            630: { under: "2 / 1", over: "2 / 5", yardage: 4.5 },
            642: { under: "9 / 5", over: "4 / 9", yardage: 5.5 },
            654: { under: "6 / 4", over: "8 / 15", yardage: 6.5 },
            666: { under: "6 / 5", over: "4 / 6", yardage: 7.5 },
            678: { under: "21 / 20", over: "4 / 5", yardage: 8.5 },
            690: { under: "EVS", over: "5 / 6", yardage: 9.5 },
            702: { under: "20 / 21", over: "9 / 10", yardage: 10.5 },
            714: { under: "9 / 10", over: "10 / 11", yardage: 11.5 },
            726: { under: "8 / 11", over: "EVS", yardage: 12.5 },
            738: { under: "4 / 6", over: "6 / 5", yardage: 13.5 },
            750: { under: "8 / 13", over: "13 / 10", yardage: 14.5 },
        },
    },
    {
        start: 7522.815,
        end: 7531.991,
        startPlay: 7527.813,
        ballX: 648,
        url: './detections/4_tracks_v8.json',
        offence_team: "home_team",
        offence_odds: {
            82: "9 / 2",
            85: "11 / 2",
            86: "5 / 1",
            87: "8 / 1",
            41: "8 / 1",
        },
        defence_odds: {
            35: "9 / 2",
            45: "11 / 2",
            54: "7 / 1",
            33: "7 / 1",
            24: "9 / 1",
            93: "33 / 1",
            58: "66 / 1",
            31: "66 / 1",
            92: "66 / 1",
        },
        progress_odds: {
            666: { under: "9 / 2", over: "2 / 13", yardage: 1.5 },
            678: { under: "4 / 1", over: "2 / 11", yardage: 2.5 },
            690: { under: "3 / 1", over: "1 / 4", yardage: 3.5 },
            702: { under: "2 / 1", over: "2 / 5", yardage: 4.5 },
            714: { under: "9 / 5", over: "4 / 9", yardage: 5.5 },
            726: { under: "6 / 4", over: "8 / 15", yardage: 6.5 },
            738: { under: "6 / 5", over: "4 / 6", yardage: 7.5 },
            750: { under: "21 / 20", over: "4 / 5", yardage: 8.5 },
            762: { under: "EVS", over: "5 / 6", yardage: 9.5 },
            774: { under: "20 / 21", over: "9 / 10", yardage: 10.5 },
            786: { under: "9 / 10", over: "10 / 11", yardage: 11.5 },
            798: { under: "8 / 11", over: "EVS", yardage: 12.5 },
            810: { under: "4 / 6", over: "6 / 5", yardage: 13.5 },
            822: { under: "8 / 13", over: "13 / 10", yardage: 14.5 },
        },
    },
];
